import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
// Les appels à Supabase ont été remplacés par fetch vers l'API PHP
import { useTranslation } from '../useTranslation';
import { NavLink } from "react-router-dom";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
const { t } = useTranslation();
   const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

 // Basic email validation
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    setMessage('Veuillez entrer une adresse email valide"');
    return;
  }
  
  setIsLoading(true);
    
    try {
      const { data, error } = await supabase
        .from('newsletter_subscriptions')
        .insert([{ email }]);
      
      if (!error) {
        setMessage(t('subscriptionSuccess'));
        setEmail('');
      } else {
        setMessage(error.message.includes('duplicate') || error.message.includes('déjà abonné')
          ? 'Vous êtes déjà abonné !'
          : 'Échec de l’abonnement. Veuillez réessayer.');
      }
    } catch (error) {
      console.error('Erreur réseau newsletter:', error);
      setMessage('Échec de l’abonnement. Veuillez réessayer.');
    } finally {
      setIsLoading(false);
      setTimeout(() => setMessage(''), 5000);
    }
  };

  return (
    <>
<footer id="footer">
    <div class="footer-top">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6">
            <div class="footer-info">
              <h3>Terroir Numidya</h3>
              <p>
  Zone industrielle
                   <br />
  Tabarka 2, Tunisie<br /><br />
  <strong>{t('phoneLabel')}</strong> +216 98 370 055<br />
  <strong>Email:</strong> rafikbj@gmail.com<br />
</p>
              <div class="social-links mt-3">
                <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>
                <a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>
                <a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
                <a href="#" class="google-plus"><i class="bx bxl-skype"></i></a>
                <a href="#" class="linkedin"><i class="bx bxl-linkedin"></i></a>
              </div>
            </div>
          </div>

          <div class="col-lg-2 col-md-6 footer-links">
            <h4>Navigation</h4>
            <ul>
              <li><i class="bx bx-chevron-right"></i> <NavLink  onClick={scrollToTop} to="/">{t('Home')}</NavLink></li>
              <li><i class="bx bx-chevron-right"></i> <NavLink  onClick={scrollToTop} to="/apropos">{t('about')}</NavLink></li>
              <li><i class="bx bx-chevron-right"></i> <NavLink  onClick={scrollToTop} to="/boutique">{t('boutique')}</NavLink></li>
              <li><i class="bx bx-chevron-right"></i> <NavLink  onClick={scrollToTop} to="/contact">{t('Contact')}</NavLink></li>
              
</ul>
          </div>

          <div class="col-lg-3 col-md-6 footer-links">
            <h4>{t('ourGallery')}</h4>
            <ul>
              <li><i class="bx bx-chevron-right"></i> <NavLink  onClick={scrollToTop} to="/galerie">{t('Gallery')}</NavLink></li>
            </ul>
             <ul><h4></h4></ul>
             <h4>{t('ourServices')}</h4>
            <ul>

 <li><i class="bx bx-chevron-right"></i> <NavLink  onClick={scrollToTop} to="https://domaine.numidia.pro/">Domaine Numidya</NavLink></li>

            </ul>
          </div>

 <div className="col-lg-4 col-md-6 footer-newsletter">
        <h4>Newsletter</h4>
        <p>{t('newsletterText')}</p>
        <form onSubmit={handleSubmit}>
          <input 
            type="email" 
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('emailPlaceholder')} 
            required
          />
        <input 
  type="submit" 
  value={isLoading ? t('subscribing') : t('signUp')} 
  disabled={isLoading}/>
        </form>
        {message && (
          <div className={`newsletter-message ${
            message.includes('Thank you') ? 'success' : 'error'
          }`}>
            {message}
          </div>
        )}
      </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="copyright">
        &copy; Copyright <strong><span>Terroir Numidya</span></strong>. {t('allRightsReserved')}
      </div>
      <div class="credits">   
        {t('createdBy')} <a href="">Amine Makni</a>
      </div>
    </div>
  </footer>

  <a href="#" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
  </>
  );
};

export default Footer;
